import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconArrowLeftStyle0 = gravityIconIndividualCss;

const GravityIconArrowLeft = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4be667226eba018cc7683e5c584edbceb9ec480a', color: this.color, size: this.size }, h("svg", { key: '8dbd67e34c14db7c99631b0d3df75ff1a6689d3f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '3d71a99dee69bbb39182c33c35850331c1f98ce7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m8.21 11.21 5.28 5.28a.3.3 0 0 0 .51-.21V5.72a.3.3 0 0 0-.51-.21l-5.28 5.28a.29.29 0 0 0 0 .42Z", fill: "currentColor" }))));
    }
};
GravityIconArrowLeft.style = GravityIconArrowLeftStyle0;

export { GravityIconArrowLeft as gravity_icon_arrow_left };

//# sourceMappingURL=gravity-icon-arrow-left.entry.js.map